/**
 * Navigation Target Mapping
 * Maps search results to their corresponding navigation targets
 */

import { SearchResult, SearchSectionId } from './types';

export function getNavigationTarget(result: SearchResult): { section: string; params?: any } {
  let params: any = {};
  
  switch (result.type) {
    case 'kunden':
      params = { customerId: result.id };
      break;
    case 'eigenvertraege':
      params = { selectedContractId: result.id };
      break;
    case 'fremdvertraege':
      params = { selectedFremdvertragId: result.id };
      break;
    case 'gesellschaften':
      // Don't pass gesellschaftId - only searchTerm (added by GlobalSearchBar)
      // This keeps user on overview page with pre-filled local search
      params = {};
      break;
    case 'ansprechpartner':
      params = { ansprechpartnerId: result.id, gesellschaftId: result.data.gesellschaft_id };
      break;
    case 'leads':
      params = { leadId: result.id, viewMode: 'list' };
      break;
    case 'aufgaben':
      params = { aufgabeId: result.id };
      break;
    case 'vertriebspartner':
      params = { partnerId: result.id };
      break;
    case 'abrechnungen':
      params = { abrechnungId: result.id };
      break;
    case 'zugaenge':
      params = { tab: 'access', highlightId: result.id, gesellschaftId: result.data.gesellschaft_id };
      break;
    case 'vermittlernummern':
      params = { tab: 'vermittlernummer', highlightId: result.id, gesellschaftId: result.data.gesellschaft_id };
      break;
    case 'rabatte':
      params = { tab: 'rabatte', highlightId: result.id, gesellschaftId: result.data.gesellschaft_id };
      break;
    case 'downloadcenter':
      params = { 
        highlightId: result.id, 
        searchTerm: result.title,
        viewMode: 'list',
        folder: result.data.kategorie
      };
      break;
    case 'buchhaltung':
      params = { belegId: result.id };
      break;
    case 'elearning':
      params = { kursId: result.id };
      break;
    case 'vorlagen':
      params = { vorlageId: result.id };
      break;
    default:
      break;
  }

  // Map type to navigation section
  const sectionMap: Record<SearchSectionId, string> = {
    kunden: 'customers',
    eigenvertraege: 'contracts',
    fremdvertraege: 'contracts',
    gesellschaften: 'produktanbieter',
    ansprechpartner: 'produktanbieter',
    leads: 'leads',
    aufgaben: 'meine-aufgaben',
    vertriebspartner: 'vertriebspartner',
    abrechnungen: 'abrechnungen',
    zugaenge: 'produktanbieter',
    vermittlernummern: 'produktanbieter',
    rabatte: 'produktanbieter',
    downloadcenter: 'downloadcenter',
    buchhaltung: 'buchhaltung',
    elearning: 'elearning',
    vorlagen: 'vorlagen',
    berichte: 'berichte',
    einstellungen: 'einstellungen',
  };

  return {
    section: sectionMap[result.type] || result.type,
    params
  };
}
